<cdk-virtual-scroll-viewport
    class="agpr-virtualScroll"
    [itemSize]="vsItemSize"
    [minBufferPx]="vsMinBufferPx"
    [maxBufferPx]="vsMaxBufferPx"
>
    <table
        role="grid"
        class="agpr-socialTable"
    >
        <thead
            #tableHeader
            *ngIf="showHeader"
            class="agpr-socialTableHead"
        >
            <tr>
                <th
                    *ngFor="let column of columns; let i = index"
                    role="columnheader"
                    id="{{id}}_tableHeader_{{i}}"
                    class="agpr-socialTableHead-cell {{ column.styleClass }}"
                    [ngClass]="{
                        'agpr-socialTableHead-cell--sortable': column.sortable
                    }"
                    [ngStyle]="{
                        'width.px': column.width,
                        'paddingLeft.px': column.headerPaddingLeft
                    }"
                    [tabindex]="column.canSelectAll ? '-1' : '0'"
                    (keyup)="handleHeaderKeyboardNavigation($event, column, i)"
                    (click)="toggleSort(column)"
                >
                    <div class="agpr-tableInput">
                        <agpr-checkbox
                            *ngIf="column.canSelectAll"
                            [id]="id + '_selectAllCheckbox'"
                            class="agpr-socialTable-checkbox"
                            [binary]="true"
                            hiddenLabel="selectAll"
                            [(ngModel)]="selectAll"
                            (ngModelChange)="selectAllRows(selectAll, column)"
                        ></agpr-checkbox>

                        <span class="agpr-socialTableHead-cell-content">
                            {{ column.heading | localize }}
                        <span
                            *ngIf='column.sortable'
                            role="img"
                            class='agpr-socialTable-sortToggle fa-solid'
                            [ngClass]="{
                                'fa-arrow-up': currentSortColumn === column && currentSortAscending,
                                'fa-arrow-down': currentSortColumn === column && !currentSortAscending
                            }"
                        ></span>
                    </span>
                    </div>
                </th>
                <th
                    *ngIf="showDelete || showView"
                    id="{{id}}_tableActionHeader"
                    class="agpr-tableHead-cell"
                    tabindex="0"
                    (keyup)="handleHeaderKeyboardNavigation($event, 'actionHeader')"
                >
                    {{ 'action' | localize }}
                </th>
            </tr>
        </thead>
        <tbody class="agpr-socialTableBody">
            <tr
                *cdkVirtualFor="let row of sortedData; let first = first; let last = last; let i = index"
                class="agpr-socialTable-row"
                (click)="onRowClick(row, $event)"
                [ngClass]="{
                    'agpr-socialTable-row--active': row === selectedRow,
                    'agpr-socialTable-row--selectableRow': selectableRow,
                    'agpr-socialTable-row--selected': row.selected
                }"
            >
                <td
                    *ngFor="let column of columns; let j = index"
                    role="gridcell"
                    id="{{id}}_tableDataCell_{{i}}_{{j}}"
                    class="agpr-socialTable-cell {{ column.cellStyleClass }}"
                    [ngClass]="{
                        'agpr-socialTable-cell--firstRow': first,
                        'agpr-socialTable-cell--lastRow': last
                    }"
                    [ngSwitch]="column.type"
                    [ngStyle]="{
                        'width.px': column.width
                    }"
                    [pTooltip]="row[column.tooltipField]"
                    tooltipPosition="top"
                    [tooltipDisabled]="editingRow === row && editingColumn === column"
                    [attr.aria-describedby]="rowSelectedAriaLabel ? id + '_rowSelectedHiddenDescription' : null"
                    tabindex="-1"
                    (keyup)="handleDataCellKeyboardNavigation($event, i, j)"
                >
                    <div
                        class="agpr-socialTable-cellContainer"
                    >
                        <agpr-checkbox
                            *ngSwitchCase="columnTypes.checkbox"
                            [id]="id + '_' + i + '_' + j + '_checkbox'"
                            class="agpr-socialTable-checkbox"
                            [ngClass]="{ 'agpr-socialTable-cell--checkbox': column.type === columnTypes.checkbox }"
                            [label]="row[column.labelField]"
                            [initiallyFocusable]="false"
                            [(ngModel)]="row[column.field]"
                            (ngModelChange)="saveCheckboxValue($event, column, row)"
                            [binary]="true"
                        ></agpr-checkbox>
                        <div
                            *ngSwitchCase="columnTypes.text"
                            class="agpr-socialTableInput"
                        >
                            <ng-template [ngIf]="editingRow === row && editingColumn === column">
                                <agpr-text-input
                                    [(ngModel)]="row[column.field]"
                                    (keyup)="saveOnEnter($event, column, row)"
                                    (blur)="saveValue(column, row)"
                                    [maxLength]="column.fieldMaxLength"
                                    [initialFocus]="true"
                                    [bottomMargin]="false"
                                    [selectOnEdit]="true"
                                    [ariaLabel]="column.heading"
                                ></agpr-text-input>
                            </ng-template>
                            <ng-template [ngIf]="editingRow !== row || editingColumn !== column">
                                <span class="agpr-socialTableInput-value">
                                    {{ row[column.field] }}
                                </span>
                                <agpr-button
                                    class="agpr-socialTableInput-icon"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltip="rename"
                                    [initiallyFocusable]="false"
                                    (click)="editField(column, row, $event)"
                                ></agpr-button>
                            </ng-template>
                        </div>
                        <div
                            *ngSwitchCase="columnTypes.textarea"
                            class="agpr-socialTableInput"
                            [ngClass]="{ 'agpr-socialTableInput--withCustomTemplate': column.customTemplate }"
                        >
                            <ng-container
                                [ngTemplateOutlet]="column.customTemplate"
                                [ngTemplateOutletContext]="{column:column, row:row}"
                            ></ng-container>
                            <ng-container>
                                <ng-template [ngIf]="editingRow === row && editingColumn === column">
                                    <agpr-textarea-input
                                        [(ngModel)]="row[column.field]"
                                        (keypress)="saveOnEnter($event, column, row)"
                                        (blur)="saveValue(column, row)"
                                        [maxlength]="column.fieldMaxLength"
                                        [initialFocus]="true"
                                        [bottomMargin]="false"
                                        [ariaLabel]="column.heading"
                                    ></agpr-textarea-input>
                                </ng-template>
                                <ng-template [ngIf]="editingRow !== row || editingColumn !== column">
                                    <div class="agpr-socialTableInput-flexContainer">
                                        <span class="agpr-socialTableInput-textarea">
                                            {{ row[column.field] }}
                                        </span>
                                        <agpr-button
                                            [style]="buttonTypes.icon"
                                            class="agpr-socialTableInput-icon"
                                            [icon]="'fa fa-duotone fa-pencil'"
                                            (click)="editField(column, row)"
                                        ></agpr-button>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </div>
                        <div
                            *ngSwitchCase="columnTypes.linkList"
                        >
                            <agpr-link-list
                                *ngIf="row[column.field]; else noLinks"
                                class="agpr-socialTableInput-value"
                                [links]="row[column.field]"
                                [itemsMessage]="column.message"
                            ></agpr-link-list>

                            <ng-template #noLinks>
                                <span class="agpr-socialTableInput-value--emptyLinks">
                                    --
                                </span>
                            </ng-template>
                        </div>
                        <div
                            *ngSwitchCase="columnTypes.custom"
                        >
                            <ng-container
                                [ngTemplateOutlet]="column.customTemplate"
                                [ngTemplateOutletContext]="{column:column, row:row, selectedRow:selectedRow}"
                            ></ng-container>
                        </div>
                        <span
                            *ngSwitchDefault
                        >
                            <ng-container
                                *ngIf="row[column.field] else nullPlaceholder"
                                [ngSwitch]="column.format"
                            >
                                <ng-container
                                    *ngSwitchCase="rowFormats.date"
                                >
                                    {{ row[column.field] | changeTimeZone : userPreferences?.timeZone : defaultDateFormat }}
                                </ng-container>
                                <ng-container
                                    *ngSwitchDefault
                                >
                                    {{ row[column.field] }}
                                </ng-container>
                            </ng-container>
                            <ng-template #nullPlaceholder>
                                {{ tablePlaceholders.NULL_PLACEHOLDER }}
                            </ng-template>
                        </span>
                        <span
                            *ngIf="column.showInfoCircle"
                            role="img"
                            class="fa-regular fa-circle-info agpr-table-infoCircle"
                            [agprTooltip]="row.tooltipInfo"
                            tooltipPosition="top"
                            [initiallyFocusable]="false"
                            (keyup)="handleDataCellKeyboardNavigation($event, i)"
                        ></span>
                    </div>
                </td>
                <td
                    *ngIf="showActionCell"
                    id="{{id}}_tableActionCell_{{i}}"
                    class="agpr-socialTable-cell agpr-socialTable-actions"
                    [ngClass]="{'agpr-socialTable-cell--firstRow': first }"
                    [style.width]="actionItemWidth"
                    tabindex="-1"
                >
                    <agpr-button
                        *ngIf="showView"
                        class="agpr-socialTableRow-action"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-eye"
                        [tooltip]="viewIconTooltip"
                        [initiallyFocusable]="false"
                        (keyup)="handleActionCellKeyboardNavigation($event, i)"
                        (click)="view(row)"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="showDelete"
                        class="agpr-socialTableRow-action"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-trash-can"
                        [tooltip]="deleteLabel"
                        [initiallyFocusable]="false"
                        (keyup)="handleActionCellKeyboardNavigation($event, i)"
                        (click)="deleteItem(row, i)"
                    ></agpr-button>
                </td>
            </tr>
            <tr *ngIf="!sortedData || sortedData.length === 0" class="agpr-socialTable-row--emptyState">
                <td [attr.colspan]="columns.length + (showActionCell ? 1 : 0)" class="agpr-socialTable-cell--noData">
                    <agpr-message [severity]="messageSeverity.noContent">
                        {{ 'Social.intelligence.noItems' | localize }}
                    </agpr-message>
                </td>
            </tr>
        </tbody>
    </table>
    <span
        *ngIf="rowSelectedAriaLabel"
        [id]="id + '_rowSelectedHiddenDescription'"
        class="u-srOnly"
    >
        {{ rowSelectedAriaLabel | localize }}
    </span>
</cdk-virtual-scroll-viewport>
